import { FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import dexieDb from 'lib/db'
import { switchStoreRefAction } from 'reducks/auth/actions'
import { push } from 'connected-react-router'
import { initRootState } from 'reducks/auth/operations'
import { BrandType } from 'types/brand'
import { RoleType } from 'types/staff'

const switchStoreRef = (
  storeRef: FirebaseDocRefType | undefined,
  manufacturerRef: FirebaseDocRefType | undefined,
  shopRef: FirebaseDocRefType | undefined,
  isStationStaff: boolean,
  path?: string
) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const isAdmin = getState().auth.is_admin
    const roles: RoleType[] = getState().auth.roles
    const brands: BrandType[] = getState().brand.brands
    const brand = brands.find((brand) => brand.store_refs.some((_storeRef) => _storeRef.id === storeRef?.id))
    const brandRef = brand?.brand_ref
    if (typeof shopRef !== 'undefined') {
      if (isAdmin) {
        await dexieDb.auth.put({
          uid: getState().auth.uid,
          is_admin: getState().auth.is_admin,
          is_signed_in: getState().auth.is_signed_in,
          role: 9,
          brand_id: brandRef?.id,
          shop_id: shopRef.id,
          store_id: undefined,
        })
        dispatch(switchStoreRefAction({ role: 9, brandRef, storeRef, shopRef }))
      } else {
        dispatch(switchStoreRefAction({ role: 9, brandRef, storeRef, shopRef }))
      }
    } else {
      if (isAdmin) {
        await dexieDb.auth.put({
          uid: getState().auth.uid,
          is_admin: getState().auth.is_admin,
          is_signed_in: getState().auth.is_signed_in,
          role: 9,
          brand_id: brand?.brand_ref?.id,
          shop_id: undefined,
          store_id: storeRef?.id,
        })
        dispatch(switchStoreRefAction({ role: 9, brandRef, storeRef, shopRef }))
      } else {
        const role = roles.find((role) => role.store_ref.id === storeRef?.id)
        if (!role) return
        dispatch(switchStoreRefAction({ role: role.role, brandRef, storeRef, shopRef }))
      }
    }
    initRootState(dispatch)
    dispatch(push(path ?? '/'))
  }
}

export default switchStoreRef
